
import Vue from "vue";
import AppBillboard from "./Billboard.vue";

export default Vue.extend({
	props: {
		step: Number,
		showMobileLogo: Boolean
	},
	components: {
		AppBillboard
	},
});
